import { CanMatchFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CoreStore } from '@core/store/core.store';
import { userRetrieved$ } from '@core/store/core-store.utils';

export const authGuard: CanMatchFn = (route, segments): Observable<boolean | UrlTree> => {
  const coreStore = inject(CoreStore);
  const router: Router = inject(Router);

  return userRetrieved$().pipe(
    map(() => coreStore.isLogged() || router.createUrlTree(['login']))
  );
};
